@use "../../sass/variables/colors";
@use "../../sass/mixins/font-family";

ul {
  @include font-family.font(light);
  color: colors.$color-grey-text-light;
  line-height: 1.6;
  list-style-type: none;
  padding: 0;

  :host([variant='square']) & {
    --variant: square;
  }
}
